"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeTrigger = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../utils");
exports.DateRangeTrigger = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var onKeyDown = _a.onKeyDown, className = _a.className, disabled = _a.disabled, error = _a.error, onClick = _a.onClick, open = _a.open, placeholder = _a.placeholder, value = _a.value, size = _a.size, required = _a.required, onChange = _a.onChange;
    var _c = react_1.default.useState(value), valueRange = _c[0], setValueRange = _c[1];
    var TriggerClasses = classnames_1.default('Trigger', className, (_b = {
            'Trigger--open': open,
            'Trigger--error': error,
            'Trigger--disabled': disabled
        },
        _b["Trigger--s-" + size] = size,
        _b));
    var handleKey = function (e) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    var getShortLabel = function () {
        return (react_1.default.createElement("div", { className: "DateRangeTrigger__shortLabel" },
            react_1.default.createElement(__1.Icon, { name: "event", size: "20px" })));
    };
    var getArrow = function () {
        return open ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
    };
    var valueString = valueRange.start &&
        valueRange.end &&
        utils_1.toDateFormat.shortMonth(valueRange.start) + " -\n\t\t" + utils_1.toDateFormat.shortMonth(valueRange.end);
    var getValues = function () {
        if (valueString)
            return (react_1.default.createElement(__1.BodyText, { className: "Trigger__value" }, valueString));
        return (react_1.default.createElement(__1.BodyText, { className: "Trigger__placeholder" }, placeholder));
    };
    var clearClick = function (e) {
        onChange({ start: null, end: null });
        setValueRange({ start: null, end: null });
        e.preventDefault();
        e.stopPropagation();
    };
    var getClearable = function () {
        if (!valueString || valueString.length === 0 || required)
            return;
        return (react_1.default.createElement(__1.Tooltip, { text: disabled ? null : 'Clear selection', className: "d-f" },
            react_1.default.createElement(__1.Button, { disabled: disabled, xsmall: true, fill: "subtle", iconName: "clear", onClick: clearClick, className: "Trigger__clear" })));
    };
    var handleClick = function (e) {
        return onClick === undefined ? null : onClick(e);
    };
    var _d = react_1.default.useContext(__1.FormFieldContext), inputId = _d.labelFor, setFormFieldContext = _d.setFormFieldContext;
    react_1.default.useEffect(function () {
        setFormFieldContext({
            inputRef: ref,
        });
        return function () { return setFormFieldContext({ inputRef: undefined }); };
    }, []); // eslint-disable-line
    react_1.default.useEffect(function () {
        setValueRange(value);
    }, [value]);
    return (react_1.default.createElement("div", { "aria-expanded": open, className: TriggerClasses, onClick: !disabled ? handleClick : undefined, tabIndex: disabled ? undefined : 0, onKeyDown: handleKey, id: inputId, ref: ref },
        react_1.default.createElement(__1.Stack, null,
            getShortLabel(),
            getValues(),
            react_1.default.createElement(__1.Stack, { className: "Trigger__controls", spacing: 1, alignItems: "flex-start" },
                getClearable(),
                react_1.default.createElement(__1.Icon, { name: getArrow(), size: "16px", className: "Trigger__arrow" })))));
});
//# sourceMappingURL=DateRangeTrigger.js.map